import { Component } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {CassError} from '@core/models/cass-error';
import {Logger} from '@core/services/logger.service';
import {UserAlertService} from '@shared/services/user-alert.service';
import {AuthService} from '@core/services/auth.service';

@Component({
  selector: 'cass-external-planner-login',
  templateUrl: './external-planner-login.component.html',
  styleUrls: ['./external-planner-login.component.css']
})
export class ExternalPlannerLoginComponent {
	private readonly COMPONENT_NAME = "ExternalPlannerLoginComponent";
	readonly callingOut$ = new BehaviorSubject<boolean>(false);

	private _token: string | null = null
	constructor(
		private _activatedRoute: ActivatedRoute,
		private _authService: AuthService,
		private _logger: Logger,
		private _alertService: UserAlertService,
		private _router: Router
	) {
		this._token = this.getTokenFromQueryParams('t')
		this.verifyToken(this._token)
	}

	private getTokenFromQueryParams(paramName: string): string | null {
		this.callingOut$.next(true);
		const token = this._activatedRoute.snapshot.queryParamMap.get(paramName)
		console.log({token});
		this.callingOut$.next(false);
		return token;
	}

	private verifyToken(token: string | null) {
		this.callingOut$.next(true);
		if (!token) {
			this._alertService.error('The supplied token is invalid, missing or expired"')
			this.callingOut$.next(false);
			return;
		}
		this._authService.authenticateWithToken(token)
			.subscribe({
				next: (res) => {
					console.log({res});
					// check if orderBasketId is not null redirect to specific order
					if (res.orderBasketId) {
						// redirect to specific order
						this._router.navigate(['/order'], {queryParams: {orderId: res.orderBasketId}})
					} else {
						// Redirect to /myAds with advertiserId & AgencyId as queryParams
						this._router.navigate(['/myads'], {queryParams: {advertiserId: res.advertiserId, agencyId: res.agencyId}})
					}
				},
				error: (error: CassError) => {
					this.callingOut$.next(false);
					this._logger.error(this.COMPONENT_NAME, "Verification failed: The supplied token is invalid, missing or expired");
					this._alertService.errorByCassError(error);
				}
			})
	}
}
